import { Input } from "@/components/ui/input";

export interface ForecastFieldsState {
  timeCol: string;
  groupCol: string;
  predictionLength: string;
  frequency: string;
}

interface Props extends ForecastFieldsState {
  columns: Array<{ name: string; dtype: string }>;
  onChange: (patch: Partial<ForecastFieldsState>) => void;
}

const FREQUENCIES = ["D", "h", "min", "W", "M", "Q", "Y"];

export function ForecastFieldsPanel({
  columns,
  timeCol,
  groupCol,
  predictionLength,
  frequency,
  onChange,
}: Props) {
  const colNames = columns.map((c) => c.name);
  return (
    <div className="grid grid-cols-2 gap-4">
      <div>
        <label
          className="font-mono text-[10px] font-semibold uppercase tracking-[0.12em] text-navy-300"
          htmlFor="time_col"
        >
          Time column
        </label>
        <Input
          id="time_col"
          list="forecast-cols"
          value={timeCol}
          onChange={(e) => onChange({ timeCol: e.target.value })}
          placeholder="e.g. date"
        />
      </div>
      <div>
        <label
          className="font-mono text-[10px] font-semibold uppercase tracking-[0.12em] text-navy-300"
          htmlFor="group_col"
        >
          Group column <span className="text-muted">(optional)</span>
        </label>
        <Input
          id="group_col"
          list="forecast-cols"
          value={groupCol}
          onChange={(e) => onChange({ groupCol: e.target.value })}
          placeholder="e.g. store_id"
        />
      </div>
      <div>
        <label
          className="font-mono text-[10px] font-semibold uppercase tracking-[0.12em] text-navy-300"
          htmlFor="pred_len"
        >
          Prediction length
        </label>
        <Input
          id="pred_len"
          type="number"
          min={1}
          value={predictionLength}
          onChange={(e) => onChange({ predictionLength: e.target.value })}
          placeholder="e.g. 30"
        />
      </div>
      <div>
        <label
          className="font-mono text-[10px] font-semibold uppercase tracking-[0.12em] text-navy-300"
          htmlFor="freq"
        >
          Frequency
        </label>
        <select
          id="freq"
          value={frequency}
          onChange={(e) => onChange({ frequency: e.target.value })}
          className="h-8 w-full rounded-md border border-border-strong bg-surface-2 px-2.5 py-1 font-mono text-xs"
        >
          <option value="">(auto)</option>
          {FREQUENCIES.map((f) => (
            <option key={f} value={f}>
              {f}
            </option>
          ))}
        </select>
      </div>
      <datalist id="forecast-cols">
        {colNames.map((n) => (
          <option key={n} value={n} />
        ))}
      </datalist>
    </div>
  );
}
